/* eslint-disable import/extensions */
/* eslint-disable import/order */
/* eslint no-use-before-define: 0 */
import React, { useRef, useState } from "react";
import Button from "../../common/Button";
import Icon from "../../common/Icon";
import { isBlockActive } from "../../utils/SlateUtilityFunctions";
import usePopup from "../../utils/customHooks/usePopup";
import { insertEmbed } from "../../utils/embed.js";
import { Transforms } from "slate";
import Uploader from "../../../../Uploader/uploader";
import URL from "../../../../../config/api";

import { ReactEditor } from "slate-react";
import "./Embed.css";
import { CButton } from "@coreui/react";

const Embed = ({ editor, format, size }) => {
  const urlInputRef = useRef();
  const [showInput, setShowInput] = usePopup(urlInputRef);
  const [formData, setFormData] = useState({
    url: "",
    alt: ""
  });
  const [selectedImage, setSelectedImage] = useState(false);
  const [selection, setSelection] = useState();
  const handleButtonClick = e => {
    e.preventDefault();
    setSelection(editor.selection);
    selection && ReactEditor.focus(editor);

    setShowInput(prev => !prev);
  };
  const handleFormSubmit = e => {
    e.preventDefault();

    selection && Transforms.select(editor, selection);
    selection && ReactEditor.focus(editor);

    insertEmbed(editor, { ...formData }, format);
    setShowInput(false);
    setFormData({
      url: "",
      alt: ""
    });
    setSelectedImage(false);
  };

  const done = uploads => {
    setFormData({ url: URL.img + uploads[0] });
    insertEmbed(editor, { ...formData }, format);
    setSelectedImage(true);

    // this.setState(() => ({
    //   image: URL.img + uploads[0]
    // }));
  };
  const handleImageUpload = image => {
    setSelectedImage(image);
    insertEmbed(editor, { ...selectedImage }, "image");
    setShowInput(false);
  };
  return (
    <div ref={urlInputRef} className="popup-wrapper">
      <Button
        active={isBlockActive(editor, format)}
        style={{
          border: showInput ? "1px solid lightgray" : "",
          borderBottom: "none"
        }}
        format={format}
        onClick={handleButtonClick}
      >
        <Icon icon={format} />
      </Button>
      {showInput && (
        <div className="d-flex flex-column popup">
          {format === "image" && (
            <div>
              <Uploader
                type="lo"
                maxFiles={1}
                acceptedFileTypes={["image/*"]}
                allowMultiple
                labelIdle='Arraste e solte sua imagem ou <span class="filepond--label-action">procure</span>'
                done={uploads => done(uploads)}
              />
              <p style={{ textAlign: "center", opacity: "0.7", width: "100%" }}>
                OU
              </p>
            </div>
          )}
          <input
            type="text"
            placeholder="Insira a url"
            value={selectedImage ? "" : formData.url}
            onChange={e => setFormData({ url: e.target.value })}
          />

          <CButton
            onClick={handleFormSubmit}
            className="align-self-stretch mt-2"
            size="sm"
            color="primary"
          >
            Inserir
          </CButton>
        </div>
      )}
    </div>
  );
};

export default Embed;
